import { audioDataStore } from "./AudioDataStore";

function FileLoader() {
  const self = {};

  self.loadMetadata = async (url, audiCache, processData, notFound) => {
    const cacheMetadata = audiCache[url];

    const entry = await audioDataStore.getMetadata(url);
    const isNew = entry ? false : true;

    fetch(url, { method: "HEAD" }).then((response) => {
      if (response.status === 404) {
        notFound(url);

        return;
      }

      const lastModified = response.headers.get("last-modified");

      const insert = async () => {
        await audioDataStore.addMetadata({ id: url, lastModified, isNew });
      };

      insert();

      const data = entry ? entry : {};

      if (data.lastModified !== lastModified || !data.duration) {
        if (cacheMetadata && cacheMetadata.lastModified === lastModified && cacheMetadata.duration) {
          processData(url, cacheMetadata);
          return
        }

        const newVersion = async () => {
          await audioDataStore.updateMetadata({ id: url, isNew: true });
        };

        newVersion();

        self.load(url, processData, notFound);
      } else {
        processData(url, data);
      }
    });
  };

  self.load = (url, processData, notFound) => {
    return self.fetch(url, processData, notFound);
  };

  self.fetch = (url, processData, notFound) => {
    fetch(url)
      .then((response) => {
        if (!response.ok) {
          notFound(url);

          return null;
        }

        return response.arrayBuffer();
      })
      .then((data) => {
        if (data) processData(url, data);
      });
  };

  return self;
}

export const loader = new FileLoader();
